module.exports = __webpack_public_path__ + "static/logoyellowwhite-9bad6581647f8478d176343307356eb9.png";